"use strict";
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var cosmosBase = /** @class */ (function () {
    function cosmosBase() {
        this.defaultGas = 100000;
        this.minGasprice = 0.0025;
        this.minimalTransactionAmount = new bignumber_js_1.BigNumber(10000);
        this.version = "v1beta1";
        this.gas = {
            // refer to https://github.com/chainapsis/keplr-wallet/blob/master/packages/stores/src/account/cosmos.ts#L113 for the gas fees
            // TODO use simulate endpoint to evaluate tx gas instead of constant gas
            send: 90000,
            delegate: 250000,
            undelegate: 250000,
            redelegate: 300000,
            claimReward: 180000,
            claimRewardCompound: 400000
        };
    }
    cosmosBase.COSMOS_FAMILY_LEDGER_VALIDATOR_ADDRESSES = [];
    return cosmosBase;
}());
exports["default"] = cosmosBase;
//# sourceMappingURL=cosmosBase.js.map